import styled from 'styled-components';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';
import {HOME_PAGE} from '../../../../themes/css-global-classes';

const DefaultBox = styled.div`
    flex: 0 0 auto;
    margin: 1rem 1rem 3rem;
    align-self: stretch;
`;

export const PcBox = styled(DefaultBox)`
    width: calc((100% / 5) * 2);

    .${HOME_PAGE} & {
        width: calc((100% / 6) * 2);
    }
    @media ${({theme}) => theme.mediaQuery.xlAndBelow}, ${({theme}) => theme.mediaQuery.lowHeight} {
        .${HOME_PAGE} & {
            width: calc((100% / 6) * 2 * 0.9);
        }
    }
`;

/* 
    @TODO: if and when red tiger will make the widget responsible, lower down 
    the width on mobile portrait to match 888 daily jp widget
*/
export const MobileBox = styled(DefaultBox)`
    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        width: calc((100% / 6) * 2);
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        width: calc(100% / 3);
        margin: 1rem 1.5rem 0;
    }
`;

export const RedTigerWidgetDefaultBox = styledByDevice(PcBox, MobileBox);